// Status Colors, Labels and Columns for Orders Table
export const statusColors = {
  paid: 'bg-green-100 text-green-800',
  failed: 'bg-red-100 text-red-800',
  pending: 'bg-yellow-100 text-yellow-800',
  processing: 'bg-blue-100 text-blue-800',
  cancelled: 'bg-red-100 text-red-800',
  picked_up: 'bg-indigo-100 text-indigo-800',
  in_transit: 'bg-orange-100 text-orange-800',
  delivered: 'bg-green-100 text-green-800',
  ready_for_pickup: 'bg-purple-100 text-purple-800',
  refunded: 'bg-gray-100 text-gray-800',
}

export const orderStatusLabels = {
  pending: 'Pending',
  processing: 'Processing',
  cancelled: 'Cancelled',
  ready_for_pickup: 'Ready for Pickup',
  refunded: 'Refunded',
  picked_up: 'Picked Up',
  in_transit: 'In Transit',
  delivered: 'Delivered',
}

export const userRoles = {
  admin: 'Admin',
  business: 'Business',
  customer: 'Customer',
  delivery_driver: 'Delivery Driver',
}

export const paymentStatusLabels = {
  paid: 'Paid',
  pending: 'Pending',
  failed: 'Failed',
}



export const columns = [
  { key: 'id', label: 'Order ID', format: (item: {id: string}) => `#${item?.id || 'N/A'}` },
  { key: 'business', label: 'Business' },
  { key: 'customer', label: 'Customer' },
  { key: 'total', label: 'Total' },
  { key: 'order_status', label: 'Order Status' },
  { key: 'payment_status', label: 'Payment Status' },
  { key: 'date', label: 'Date' },
  // { key: 'actions', label: 'Actions' },
]


export const nairaSymbol = '₦'

// export const serviceFeePercentage = 0.075 // 7.5%
// export const businessServiceFeePercentage = 0.05 // 5%

// export const deliveryFee = 2000



export const businessCategories = [
  'Grocery Store',
  'Farmers Market',
  'Specialty Food Store',
  'Restaurant',
  'Cafe',
  'Bar',
  'Convenience Store',
  'Organic Market',
  'International Market',
  'Bakery',
  'Butcher Shop',
  'Seafood Market',
  'Dairy Store',
  'Pharmacy',
  'Supermarket',
  'Fast Food',
  'Other',
]

export const paginationDefault = {
  current_page: 1,
  last_page: 1,
  per_page: 10,
  total: 0,
  from: 0,
  to: 0,
}

export const businessQRCodeUrl = (business: Business) => {
  return `${window.location.origin}/businesses/${business?.uuid}`
}

